import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Spend lines (BP-08/D-047) — transactional records at invoice-line grain, referencing the supplier
 * and category masters by ID (D-100). Lean first cut: amount, currency, date, plus optional supplier/
 * category links and an AI classification confidence (set later). Analytics (the cube, findings,
 * payment terms) compute from these lines in later slices. Shapes shared by the API and the web app.
 */
export const spendLineSchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema.nullable(),
    categoryId: uuidSchema.nullable(),
    description: z.string().nullable(),
    amount: z.number(),
    currency: z.string(),
    spendDate: z.string(), // ISO date (YYYY-MM-DD)
    source: z.enum(['manual', 'ap_upload', 'card', 'ai_seeded']),
    classificationConfidence: z.number().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date as YYYY-MM-DD');
/** POST /spend/lines — add a spend line (source 'manual'). */
export const createSpendLineSchema = z
    .object({
    supplierId: uuidSchema.optional(),
    categoryId: uuidSchema.optional(),
    description: z.string().trim().max(500).optional(),
    amount: z.number().finite(),
    currency: z.string().trim().length(3).optional(), // ISO 4217
    spendDate: isoDate,
})
    .strict();
/** PATCH /spend/lines/:id — edit amount / links / date / description. */
export const patchSpendLineSchema = z
    .object({
    supplierId: uuidSchema.nullable().optional(),
    categoryId: uuidSchema.nullable().optional(),
    description: z.string().trim().max(500).nullable().optional(),
    amount: z.number().finite().optional(),
    currency: z.string().trim().length(3).optional(),
    spendDate: isoDate.optional(),
})
    .strict();
//# sourceMappingURL=spend.js.map